export * from './GlowTabs';
export type { Tab } from './hooks';
